export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "all_program": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全てのリサイクルプログラム"])}
    }
  })
}
